import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

const ArticleContainer = styled.div`
  background: var(--dark);
  padding: 40px 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    padding: 24px 12px;
  }
`;

const ArticleContent = styled.div`
  width: 100%;
  max-width: 850px;
  background: var(--card-bg);
  border-radius: var(--border-radius);
  padding: 32px;
  box-shadow: var(--shadow);
  color: var(--light);

  h2 {
    font-size: 2.2rem;
    color: var(--primary);
    margin-bottom: 20px;
    text-align: center;
  }

  h3 {
    font-size: 1.4rem;
    color: var(--accent);
    margin-bottom: 16px;
    text-align: center;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.7;
    margin-bottom: 16px;
    color: #e0e0e0;
  }

  img {
    width: 100%;
    border-radius: 10px;
    margin: 20px 0;
  }

  iframe {
    width: 100%;
    height: auto;
    min-height: 220px;
    border-radius: 10px;
  }

  @media (max-width: 768px) {
    padding: 20px;

    h2 {
      font-size: 1.8rem;
    }

    h3 {
      font-size: 1.2rem;
    }

    p {
      font-size: 1rem;
    }
  }
`;

const BackButton = styled.button`
  background: var(--primary);
  color: var(--dark);
  border: none;
  padding: 12px 26px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 24px;
  transition: 0.3s ease;

  &:hover {
    background: var(--accent);
  }

  @media (max-width: 600px) {
    width: 100%;
    padding: 14px 0;
  }
`;

const ArchivedArticlePage = () => {
  const { articleId } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState({
    title: 'Article Not Found',
    subheader: '',
    paragraphs: ['Article not found.']
  });

  useEffect(() => {
    const fetchArchivedArticle = async () => {
      const { data, error } = await supabase
        .from('archived_articles')
        .select('title, subheader, content')
        .eq('article_id', articleId)
        .single();

      if (error || !data) {
        setArticle({
          title: 'Archived Article Not Found',
          subheader: '',
          paragraphs: ['This archived article could not be found.']
        });
      } else {
        const paragraphs = data.content
          .split('\n')
          .map(line => line.trim())
          .filter(line => line.length > 0);

        setArticle({
          title: data.title,
          subheader: data.subheader,
          paragraphs
        });
      }
    };

    fetchArchivedArticle();
  }, [articleId]);

  return (
    <ArticleContainer>
      <BackButton onClick={() => navigate('/archived-articles')}>Back to Archived List</BackButton>
      <ArticleContent>
        <h2>{article.title}</h2>
        {article.subheader && <h3>{article.subheader}</h3>}
        {article.paragraphs.map((para, index) => (
          <p key={index}>{para}</p>
        ))}
      </ArticleContent>
    </ArticleContainer>
  );
};

export default ArchivedArticlePage;